import React, { ReactElement, useState, RefObject } from 'react';
import { Merge } from '../../../utilities/types';
import { InputError } from '../InputError';

import {
  Container,
  InputWrapper,
  InputField,
  Prefix,
  Postfix,
  Label,
  LabelBackground,
} from './styles';

export const Input: React.FC<InputProps> = ({
  name,
  prefix,
  postfix,
  label,
  onBlur,
  onChange,
  disabled,
  error,
  hasError,
  value,
  dataCy,
  className,
  ...inputProps
}) => {
  const [active, setActive] = useState(false);

  return (
    <Container
      className={className}
      disabled={disabled}
      $hasError={!!error || !!hasError}
      data-cy={dataCy}
    >
      <InputWrapper $active={active}>
        {prefix && <Prefix>{prefix}</Prefix>}
        <InputField
          {...inputProps}
          name={name}
          value={value}
          readOnly={disabled}
          disabled={disabled}
          onFocus={() => setActive(true)}
          onChange={onChange}
          onBlur={(event: React.FocusEvent) => {
            setActive(false);
            if (onBlur) {
              onBlur(event);
            }
          }}
        />
        <Label $atTop={!!(value || value === 0 || active)} disabled={disabled}>
          <LabelBackground />
          {label}
        </Label>
        {postfix && <Postfix>{postfix}</Postfix>}
      </InputWrapper>
      {!!error && <InputError>{error}</InputError>}
    </Container>
  );
};

export type InputProps = Merge<
  React.DetailedHTMLProps<React.InputHTMLAttributes<any>, HTMLInputElement>,
  {
    ref?:
      | ((instance: HTMLInputElement | null) => void)
      | RefObject<HTMLInputElement>
      | null
      | undefined;
    name?: string;
    prefix?: ReactElement;
    postfix?: string | ReactElement;
    value?: string | number;
    label?: string;
    disabled?: boolean;
    error?: string;
    hasError?: boolean;
    dataCy?: string;
    className?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent) => void;
  }
>;
